import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-ctc-details',
  templateUrl: './ctc-details.component.html',
  styleUrls: ['./ctc-details.component.css']
})
export class CtcDetailsComponent implements OnInit {
  user : any;

  constructor(private masterDataService:MasterDataService) { }

  ngOnInit(): void {
    this.loadUserDetails();
  }

  loadUserDetails(){
    this.masterDataService.getUserProfile()
    .subscribe(res => {
      console.log(res);
      this.user =  res;
    });
  }

}
